import { DSNCColumns, DSResource } from 'shared-definitions/types'
import { ApiComponent, ApiComponentEzCol } from 'data-source/types.wp'

interface ColumnsOpts<T extends DSResource, A extends ApiComponent> {
  componentItemMapper: (input: A) => T | T[]
}

export function ncColumns<T extends DSResource, A extends ApiComponent>(
  input: ApiComponentEzCol<A>,
  opts: ColumnsOpts<T, A>
): DSNCColumns<T> {
  return {
    resource: 'nc-columns',
    perRow: input.columns_per_row,
    columns: input.columns.map(item => ({
      items: item.content.flatMap(opts.componentItemMapper),
      span: item.span,
    })),
  }
}
